import { CONFIRM_ROSTER_PLAYER, DISMISS_GAME_REPORT_REFEREE_CHANGES, UPDATE_GAME_REPORT_REFEREE } from '../constants/actionTypes';

export const confirmRosterPlayer = ( gameId, playerId, isConfirmed ) => {

    return {
        type:    CONFIRM_ROSTER_PLAYER,
        payload: { gameId, playerId, isConfirmed }
    };

};

export const dismissGameReportRefereeChanges = gameId => {

    return {
        type:    DISMISS_GAME_REPORT_REFEREE_CHANGES,
        payload: { gameId }
    };

};

export const updateGameReportReferee = ( gameId, data ) => {

    return {
        type:    UPDATE_GAME_REPORT_REFEREE,
        payload: { gameId, data }
    };

};